import Decimal from "decimal.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AudioControls } from "../game/audio/index.js";
import { selectBalance, selectConfig, useRoundStore } from "../state/roundStore.js";
import { ConnectionBadge } from "../ui/ConnectionBadge.js";
import { StrokeIcon } from "../ui/StrokeIcon.js";
import { MainNavigation } from "./MainNavigation.js";
import { Link, ROUTES } from "./router/index.js";

export function TopBar() {
  const { t } = useTranslation();
  const config = useRoundStore(selectConfig);
  const currency = config?.currencies[0];
  const balance = useRoundStore(selectBalance(currency?.code ?? ""));
  const amount = balance ? new Decimal(balance.balance).toFixed(currency?.decimals ?? 2) : "—";
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="cx-topbar">
      <div className="cx-topbar__brand-group">
        <a className="cx-wordmark" href="/" aria-label={t("app.name")}>
          <span>CRASH</span>
          <span>X</span>
        </a>
        <div className="cx-desktop-navigation">
          <MainNavigation />
        </div>
      </div>
      <div className="cx-topbar__actions">
        <div className="cx-topbar__connection">
          <ConnectionBadge />
        </div>
        <Link
          to={ROUTES.wallet}
          className="cx-balance-pill"
          aria-label={t("balance.openWallet")}
          title={t("recharge.openWallet")}
        >
          <span>
            <strong>{amount}</strong>
            <small>{currency?.code ?? t("balance.fun")}</small>
            {balance && new Decimal(balance.balance).minus(balance.locked).lte(0) && (
              <small>{t("recharge.title")}</small>
            )}
          </span>
          <StrokeIcon name="plus" size={16} />
        </Link>
        <div className="cx-topbar__audio">
          <AudioControls />
        </div>
        <span className="cx-account-avatar" aria-label={t("nav.profile")}>
          <StrokeIcon name="profile" size={20} />
        </span>
        <button
          type="button"
          className="cx-mobile-menu-trigger"
          aria-label={t("nav.menu")}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((value) => !value)}
        >
          <StrokeIcon name="menu" />
        </button>
      </div>
      {menuOpen ? (
        <div className="cx-mobile-menu" onClick={() => setMenuOpen(false)}>
          <MainNavigation />
        </div>
      ) : null}
    </header>
  );
}
